const e = { last_updated: "Dernière mise à jour", Series_type: "Séries", "How to guide_type": "Guide", FAQ_type: "Par défaut" }, t = {
  articles: e
};
export {
  e as articles,
  t as default
};
//# sourceMappingURL=help-center-knowledge-anatomies27.js.map
